/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PackingItemVo } from './PackingItemVo';
import {
    PackingItemVoFromJSON,
    PackingItemVoFromJSONTyped,
    PackingItemVoToJSON,
    PackingItemVoToJSONTyped,
} from './PackingItemVo';

/**
 * 
 * @export
 * @interface ResponseListPackingItemVo
 */
export interface ResponseListPackingItemVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListPackingItemVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListPackingItemVo
     */
    message?: string;
    /**
     * 
     * @type {Array<PackingItemVo>}
     * @memberof ResponseListPackingItemVo
     */
    data?: Array<PackingItemVo>;
}

/**
 * Check if a given object implements the ResponseListPackingItemVo interface.
 */
export function instanceOfResponseListPackingItemVo(value: object): value is ResponseListPackingItemVo {
    return true;
}

export function ResponseListPackingItemVoFromJSON(json: any): ResponseListPackingItemVo {
    return ResponseListPackingItemVoFromJSONTyped(json, false);
}

export function ResponseListPackingItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListPackingItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PackingItemVoFromJSON)),
    };
}

export function ResponseListPackingItemVoToJSON(json: any): ResponseListPackingItemVo {
    return ResponseListPackingItemVoToJSONTyped(json, false);
}

export function ResponseListPackingItemVoToJSONTyped(value?: ResponseListPackingItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PackingItemVoToJSON)),
    };
}

